module.exports = __webpack_public_path__ + "img/logic-blue.37d94088.svg";